import { Component } from 'react';
import { connect } from 'react-redux';
import styles from './AscertainmentModal.scss';
import icons from 'styles/icons/icons.scss';
import LoadingComponent from 'common/permissions/components/LoadingComponent';

import {
    saveIndexDocument,
    closeAscertainmentModal
} from 'indexDocuments/actions';

class AscertainmentModal extends Component {
    render() {
        const {
            ascertainmentLoading,
            ascertainmentResult,
            confirmAction,
            editAction
        } = this.props;

        if (ascertainmentLoading) {
            return (
                <div className={styles.ascertainmentModalContainer}>
                    <LoadingComponent text="Validating"/>
                </div>
            );
        }
        // if ascertainment failed, show confirmation modal
        if (ascertainmentResult === false) {
            const shouldRedirectToSDFAUponSuccessfulSave = false;
            return (
                <div className={styles.ascertainmentModalContainer} data-cy="AscertainmentModal">
                    <div className={styles.ascertainmentModal}>
                        <header className={styles.warningHeader}>
                            <h2>Warning</h2>
                        </header>
                        <div className={styles.warningSection}>
                            <div className={styles.warningIconSection}>
                                <span className={icons.materialIcons}>warning</span>
                            </div>
                            <section className={styles.warningInstructions}>
                                <p>
                                    If this document is saved with these document attributes, then this document will not show up in this
                                    binder.
                                </p>
                                <p>
                                    To continue with saving this document, click Save.
                                </p>
                                <p>
                                    Otherwise, please click Modify to change these document attributes to belong to the binder.
                                </p>
                            </section>
                        </div>
                        <section className={styles.warningButtons}>
                            <button type="button" onClick={() => confirmAction(shouldRedirectToSDFAUponSuccessfulSave)}
                                className={styles.warningSaveButton} data-cy="AscertainmentModal-Save">Save</button>
                            <button type="button" onClick={editAction}
                                className={styles.warningButton} data-cy="AscertainmentModal-Modify">Modify</button>
                        </section>
                    </div>
                </div>
            );
        }
        return null;
    }
}

export default connect(state => {
    const {
        indexDocument: {
            ascertainmentLoading,
            ascertainmentResult
        }
    } = state;
    return {
        ascertainmentLoading,
        ascertainmentResult
    };
}, {
    confirmAction: saveIndexDocument,
    editAction: closeAscertainmentModal
})(AscertainmentModal);